import { EqMagModal } from './EqMagModal';

export const EqMsMagModal = EqMagModal({
  title: 'Ms Magnitude',
  desc: 'The Ms magnitude is the surface-wave magnitude of the earthquake.',
});
